import { delimitedToNumber, isNumber, numberToDelimited } from '~/components/utils/core/number';
import { validateNumberInput } from '~/components/utils/keys';

export const formatNumber = {
  methods: {
    numberToDelimitedFormatter(v: string): string {
      const input = Number(v);

      return isNumber(input) && input > 0 ? numberToDelimited(input) : v;
    },
    delimitedToNumberParser(v: string): number {
      return delimitedToNumber(v);
    },
    validateNumberInput(event: KeyboardEvent): void {
      validateNumberInput(event);
    },
  },
};

export const resettable = {
  methods: {
    resetData() {
      // @ts-expect-error TS does not know that this is a Vue mixin
      Object.assign(this.$data, this.$options.data.call(this));
    },
  },
};
